import type { FormResponse } from "@tellescope/types-models";
import { formatDateTime } from "@tellescope/utils";
import { useTranslation } from "react-i18next";
import { FormAnswer } from "./FormAnswer";

interface PrintableResponseProps {
  formResponse: FormResponse;
}

export const PrintableResponse = ({ formResponse }: PrintableResponseProps) => {
  const { t } = useTranslation("forms");

  return (
    <div className="p-8 space-y-4 text-black">
      <h1 className="text-xl font-semibold">{formResponse.formTitle}</h1>
      {formResponse.submittedAt && (
        <p className="text-sm">
          {t("Submitted {{timestamp}}", { timestamp: formatDateTime(formResponse.submittedAt) })}
        </p>
      )}
      <div className="space-y-3">
        {formResponse.responses?.map((response) => (
          <FormAnswer key={response.fieldId} title={response.fieldTitle} answer={response.answer} />
        ))}
      </div>
    </div>
  );
};
